export class State {
  courierId?: number;
  formatCourier?: string;
  id?: number;
  name?: string;
  code?: string;
  description?: string;
  active?: boolean;
  formatActive?: string;
  createdBy?: string;
  createdDate?: Date;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
}
